import { useContext } from 'react';
import { Plus } from 'react-feather';
import { MenuContext } from '../menu/menuManager/menuManager';
import cn from 'classnames';

import './plusBtn.scss';

const PlusButton = () => {
  const { setOpen, open } = useContext(MenuContext);

  return (
    <button
      className={cn('plus-button', { open })}
      onClick={() => setOpen(!open)}>
      <Plus />
    </button>
  );
};

export default PlusButton;
